import { combineReducers } from '@ngrx/store';

import { type BlocksState, BLOCKS_FEATURE_KEY, blocksReducer } from './blocks/blocks.reducer';
import { type SectionsState, SECTIONS_FEATURE_KEY, sectionsReducer } from './sections/sections.reducer';
import { type ColumnsState, COLUMNS_FEATURE_KEY, columnsReducer } from './columns/columns.reducer';
import { type TabsState, TAB_FEATURE_KEY, tabsReducer } from './tabs/tabs.reducer';
import { type GridsState, GRIDS_FEATURE_KEY, gridsReducer } from '@web/store/page-structure/grids/grids.reducer';
import { type WidgetState, WIDGETS_FEATURE_KEY, widgetsReducer } from './widgets/widgets.reducer';
import {
    type WidgetsErrorsState,
    WIDGETS_ERRORS_FEATURE_KEY,
    widgetsErrorsReducer,
} from './widgets-errors/widgets-errors.reducer';

export type PageStructureState = {
    [BLOCKS_FEATURE_KEY]: BlocksState;
    [SECTIONS_FEATURE_KEY]: SectionsState;
    [COLUMNS_FEATURE_KEY]: ColumnsState;
    [TAB_FEATURE_KEY]: TabsState;
    [GRIDS_FEATURE_KEY]: GridsState;
    [WIDGETS_FEATURE_KEY]: WidgetState;
    [WIDGETS_ERRORS_FEATURE_KEY]: WidgetsErrorsState;
};

export const PAGE_STRUCTURE_FEATURE_KEY = 'pageStructure';

export const pageStructureReducer = combineReducers<PageStructureState>({
    [BLOCKS_FEATURE_KEY]: blocksReducer,
    [SECTIONS_FEATURE_KEY]: sectionsReducer,
    [COLUMNS_FEATURE_KEY]: columnsReducer,
    [TAB_FEATURE_KEY]: tabsReducer,
    [GRIDS_FEATURE_KEY]: gridsReducer,
    [WIDGETS_FEATURE_KEY]: widgetsReducer,
    [WIDGETS_ERRORS_FEATURE_KEY]: widgetsErrorsReducer,
});
